// @flow

import ko from 'rgs-knockout';

import type { Observable } from 'rgs-knockout';

type YandexSmartCaptchaOptions = {
	// Html element id
	id: ?string,
	validationSource: ?Observable,
}

export default class YandexSmartCaptchaModel {
	constructor (options: YandexSmartCaptchaOptions) {
		this.elementId = options.id || 'captcha-container';
		this.validationSource = options.validationSource || ko.observable();
	}
}